<script lang="ts">
  import type { AppDownloadButtonsComponentProps } from './types';
  import DownloadButton from './DownloadButton.svelte';

  type $$Props = AppDownloadButtonsComponentProps;
</script>

{#if $$props.apple.url || $$props.google.url}
  <div class="AppDownloadButtonsComponent" data-entry-id={$$props.entryId}>
    {#if $$props.apple.url}
      <DownloadButton store={$$props.apple} dataPlatform="apple-button" />
    {/if}
    {#if $$props.google.url}
      <DownloadButton store={$$props.google} dataPlatform="google-button" />
    {/if}
  </div>
{/if}

<style lang="scss">
  .AppDownloadButtonsComponent {
    display: flex;
    gap: var(--space-10);
    width: auto;
  }
</style>
